export default __webpack_public_path__ + "static/media/newresonance1.2080b0a5.png";